module.exports = __webpack_public_path__ + "img/ic_services_family.d4a61ded.svg";